<template>
<layout-crumb :opts="[{label: task.siteName}, {label: $route.meta.label}]">
  <section class="check-item-wrapper">
    <section class="check-item-left">
      <section class="check-item-left-header">评分检查项目</section>
      <ul class="check-item-categories">
        <li
          v-for="(checkItemCategory, checkItemCategoryIndex) in formatCheckItemCategories"
          :key="checkItemCategoryIndex"
          :class="{finished: checkItemCategoryIndex === currentCheckItemCategoryNo}"
          class="check-item-category-wrapper"
        >
          <section class="check-item-category-title">{{checkItemCategory.name}}</section>
          <ul class="check-item-category-body">
            <li
              v-for="(checkItem, checkItemIndex) in checkItemCategory.checkItems"
              :key="checkItemIndex"
              :class="{
                finished: checkItem.isCompleted,
                'not-full-marks': checkItem.isCompleted && checkItem.score < checkItem.fullMarks,
                deleted: checkItem.isDelete,
                checking: checkItemCategoryIndex === currentCheckItemCategoryNo && checkItemIndex === currentCheckItemNo
              }"
              class="check-item-no"
              @click="onCheckItemClick(checkItemCategoryIndex, checkItemIndex)"
            >{{checkItemIndex + 1}}</li>
          </ul>
        </li>
      </ul>
    </section>

    <section v-if="currentCheckItemCategory" class="check-item-right">
      <section class="check-item-right-header">
        <section class="check-item-right-header-inner">
          <section class="section-title">{{currentCheckItemCategory.name}}</section>
          <section class="check-item-content-wrapper">
            <div class="check-item-no">{{currentCheckItemNo + 1}}</div>
            <div class="check-item-content">
              <div class="check-item-content-inner">{{currentCheckItem.content}}</div>
              <div class="check-item-content-status-switch">
                <span style="font-size:12px;display:inline-block;vertical-align:middle;">是否关闭：</span>
                <van-switch v-model="currentCheckItem.isDelete" style="font-size:20px;" />
              </div>
            </div>
          </section>
          <section v-if="isNotAllComplete" class="pre-next-subject">
            <button class="next-subject" :disabled="nextDisabled" @click="onSwitchSubject(1)"></button>
            <button class="pre-subject" :disabled="preDisabled" @click="onSwitchSubject(-1)"></button>
          </section>
          <section v-else class="submit-layer">
            <button class="submit-btn" @click="onSubmitBtnClick">提交</button>
          </section>
        </section>
      </section>

      <section class="check-item-right-body">
        <section class="check-item-right-body-left">
          <section class="check-item-desc">
            <div class="section-title">评分规则</div>
            <div class="check-item-desc-text">{{currentCheckItem.description}}</div>
          </section>
          <section class="check-item-opt">
            <component
              :is="checkOptTypeMap[currentCheckItem.optionTypeId].componentName"
              :key="currentCheckItem.id"
              :check-item="currentCheckItem"
              :measure-instruments="measureInstruments"
              class="check-item-opt-inner"
            />
          </section>
        </section>

        <section class="check-item-right-body-right">
          <section class="check-item-remark">
            <div class="section-title">补充说明</div>
            <div class="check-item-remark-input">
              <textarea v-model="currentCheckItem.comment"></textarea>
            </div>
          </section>
          <section class="check-item-img">
            <section class="check-item-img-inner">
              <div class="section-title">资料图片</div>
              <div class="check-item-img-input">
                <data-image
                  v-for="(n, index) in 9"
                  :key="n"
                  :style="{left: `${(index % 3) * 35}%`, top: `${((index / 3) | 0) * 35}%`}"
                  :img-host="IMAGE_HOST"
                  :img-obj="currentCheckItem.pictureOpts[index] || null"
                  @img-click="onImgClick"
                  @take-photo="onTakePhoto"
                />
              </div>
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>

  <van-action-sheet
    v-model="imgOptsVisible"
    :actions="imageActions"
    cancel-text="取消"
    @select="onImageOptClick"
  />

  <van-overlay :show="overlayVisible">
    <van-loading type="spinner" />
  </van-overlay>
</layout-crumb>
</template>

<script>
import {mapGetters} from 'vuex'
import {Toast, ImagePreview} from 'vant'

import checkOptTypeMap from '../../components/Data/TaskResult/CheckOptTypeMap'
import SupSubReplace from '../../utils/SupSubReplace'
import FormulaMode from '../../model/FormulaMode'

const IMAGE_HOST = process.env.IMAGE_HOST

export default {
  name: 'index',
  routeInfo: {
    label: '质控评分'
  },
  data () {
    return {
      checkItemCategories: [],
      currentCheckItemCategoryNo: 0,
      currentCheckItemNo: 0,
      imgOptsVisible: false,
      overlayVisible: false,
      measureInstruments: Object.freeze([])
    }
  },
  computed: {
    ...mapGetters({
      task: 'Task/task'
    }),
    IMAGE_HOST: () => IMAGE_HOST,
    checkOptTypeMap: () => checkOptTypeMap,
    formatCheckItemCategories () {
      return this.checkItemCategories.map(({id, name, deviceCategories}) => ({
        id,
        name,
        checkItems: (Array.isArray(deviceCategories) ? deviceCategories : []).reduce((list, deviceCategory) => list.concat(deviceCategory.checkItems.filter(checkItem => checkItem.optionTypeId !== 4)), [])
      }))
    },
    isNotAllComplete () {
      return this.formatCheckItemCategories.some(({checkItems}) => checkItems.some(checkItem => !checkItem.isDelete && !checkItem.isCompleted))
    },
    currentCheckItemCategory () {
      return this.formatCheckItemCategories[this.currentCheckItemCategoryNo]
    },
    currentCheckItem () {
      return this.currentCheckItemCategory.checkItems[this.currentCheckItemNo]
    },
    preDisabled () {
      return this.currentCheckItemCategoryNo === 0 && this.currentCheckItemNo === 0
    },
    nextDisabled () {
      return this.currentCheckItemCategoryNo === (this.formatCheckItemCategories.length - 1) && this.currentCheckItemNo === (this.currentCheckItemCategory.checkItems.length - 1)
    },
    imageActions () {
      return [{
        value: 'PREVIEW',
        name: '预览图片',
        callback: this.previewImage
      }, {
        value: 'DELETE',
        name: '删除图片',
        callback: this.deleteImage
      }]
    }
  },
  methods: {
    getCheckItemCategories () {
      this.$api.Grade.getTaskDetail(this.task.id).then(data => {
        // this.checkItemCategories = Object.freeze(checkItemCategories)
        this.measureInstruments = Object.freeze(data.taskMeasureInstruments)

        let checkItemCategories = data.checkItems
        checkItemCategories.forEach(({deviceCategories}) => {
          deviceCategories.forEach(deviceCategory => {
            deviceCategory.checkItems.forEach(checkItem => {
              if (!checkItem.hasOwnProperty('score')) {
                checkItem.score = null
              }

              checkItem.isCompleted = typeof checkItem.score === 'number'
              checkItem.content = deviceCategory.id ? `${checkItem.content}(${deviceCategory.name})` : checkItem.content
            })
          })
        })
        this.checkItemCategories = checkItemCategories
      }).catch(console.error)
    },
    saveCheckItem (callback) {
      setTimeout(() => {
        let {currentCheckItem} = this

        if (currentCheckItem.isDelete || currentCheckItem.isCompleted) {
          this.overlayVisible = true
          currentCheckItem.comment = SupSubReplace(currentCheckItem.comment)

          let promises = [this.$api.Grade.save(currentCheckItem, 2)]
          let {group} = currentCheckItem

          if (typeof group === 'number') {
            let {deviceCategoryId, inBlankOpts: currentOpts} = currentCheckItem
            let sameGroupCheckItems = this.currentCheckItemCategory.checkItems.filter(checkItem => checkItem !== currentCheckItem && checkItem.deviceCategoryId === deviceCategoryId && checkItem.group === group)

            sameGroupCheckItems.reduce((promises, checkItem) => {
              let {inBlankOpts} = checkItem

              if (Array.isArray(inBlankOpts) && inBlankOpts.length > 0) {
                inBlankOpts.forEach((opt, index) => {
                  let groupOpt = currentOpts[index]
                  let formulaMode = FormulaMode[opt.formulaMode]

                  opt.taskMeasureInstrumentId = groupOpt.taskMeasureInstrumentId
                  opt.theoryValue = groupOpt.theoryValue
                  opt.inputValue = groupOpt.inputValue
                  opt.value = formulaMode.getValue(opt)
                  opt.isQualified = formulaMode.isQualified(opt)
                  opt.isCompleted = true
                  opt.resultValue = opt.isQualified | 0
                })

                checkItem.isCompleted = true
                checkItem.score = inBlankOpts.reduce((count, opt) => count + (opt.isCompleted * opt.isQualified * opt.score), 0)

                promises.push(this.$api.Grade.save(checkItem, 2))
              }

              return promises
            }, promises)
          }

          Promise.all(promises).then(callback).catch(err => {
            console.error(err)
            Toast('保存失败')
          }).finally(() => {
            this.overlayVisible = false
            callback = null
          })
        } else {
          callback()
          callback = null
        }
      }, 0)
    },
    onCheckItemClick (checkItemCategoryIndex, checkItemIndex) {
      if (this.currentCheckItemCategoryNo === checkItemCategoryIndex && this.currentCheckItemNo === checkItemIndex) {
        return
      }

      this.saveCheckItem(() => {
        this.currentCheckItemCategoryNo = checkItemCategoryIndex
        this.currentCheckItemNo = checkItemIndex
      })
    },
    onSwitchSubject (step) {
      this.saveCheckItem(() => {
        let {currentCheckItemNo, currentCheckItemCategory} = this
        let checkItems = currentCheckItemCategory.checkItems
        currentCheckItemNo += step

        if (checkItems[currentCheckItemNo]) {
          this.currentCheckItemNo = currentCheckItemNo
        } else {
          this.currentCheckItemCategoryNo += step
          this.currentCheckItemNo = (currentCheckItemNo >> -1) & (this.currentCheckItemCategory.checkItems.length - 1)
        }
      })
    },
    previewImage () {
      let pictureOpts = this.currentCheckItem.pictureOpts

      ImagePreview({
        images: pictureOpts.map(({pictureFile}) => `${IMAGE_HOST}${pictureFile}`),
        startPosition: pictureOpts.indexOf(this.imgObj)
      })
    },
    deleteImage () {
      this.overlayVisible = true

      let imgObj = this.imgObj

      this.$api.TaskPicture.delete(imgObj.id).then(() => {
        let pictureOpts = this.currentCheckItem.pictureOpts
        let index = pictureOpts.indexOf(imgObj)

        if (index > -1) {
          pictureOpts.splice(index, 1)
        }
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onImageOptClick () {
      this.imgOptsVisible = false
    },
    onImgClick (imgObj) {
      this.imgObj = imgObj
      this.imgOptsVisible = true
    },
    onTakePhoto (imgBase64) {
      this.overlayVisible = true

      this.$api.TaskPicture.save({
        taskId: this.task.id,
        taskResultId: this.currentCheckItem.id,
        imageStr: imgBase64.replace(/^[^,]+,/, '')
      }, 1).then(pictureData => {
        this.currentCheckItem.pictureOpts.push(pictureData)
      }).catch(console.error).finally(() => {
        this.overlayVisible = false
      })
    },
    onSubmitBtnClick () {
      this.saveCheckItem(() => {
        this.overlayVisible = true

        this.$api.Grade.resultOver(this.task.id).then(() => {
          this.$router.replace({
            name: 'Sign'
          })
        }).catch(console.error).finally(() => {
          this.overlayVisible = false
        })
      })
    }
  },
  created () {
    this.getCheckItemCategories()
  }
}
</script>

<style lang="scss" scoped>
$CHECK-ITEM-LEFT-WIDTH: 21.28589263420724%;
$COMMON-SPACE: 12px;

.check-item-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding-left: $CHECK-ITEM-LEFT-WIDTH;

  .check-item-left {
    position: absolute;
    top: 0;
    left: 0;
    width: $CHECK-ITEM-LEFT-WIDTH;
  }

  .check-item-right {
    width: 100%;
    height: 100%;
  }
}

.check-item-left {
  $CHECK-ITEM-LEFT-HEADER-HEIGHT: 40px;

  height: 100%;
  margin: 0;
  padding: $CHECK-ITEM-LEFT-HEADER-HEIGHT 0 0 0;
  border-right: 1px solid #cfd0d3;

  .check-item-left-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $CHECK-ITEM-LEFT-HEADER-HEIGHT;
    line-height: $CHECK-ITEM-LEFT-HEADER-HEIGHT;
    color: #ffffff;
    background-color: #349efb;
    text-align: center;
  }
}

.check-item-categories {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  color: #414550;
  overflow: auto;
}

.check-item-category-wrapper {
  padding-top: 8px;
  border-bottom: 1px solid #cfd0d3;

  &.finished {
    background-color: #ebebeb;
  }

  .check-item-category-title {
    width: 100%;
    line-height: 30px;
    margin-bottom: -6px;
    padding: 0 $COMMON-SPACE;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .check-item-category-body {
    font-size: 0;
    margin: 0;
    padding: 0 0 $COMMON-SPACE $COMMON-SPACE;

    .check-item-no {
      $CHECK-ITEM-SIZE: 20px;

      font-size: 1rem;
      display: inline-block;
      width: $CHECK-ITEM-SIZE;
      height: $CHECK-ITEM-SIZE;
      line-height: $CHECK-ITEM-SIZE;
      margin: $COMMON-SPACE $COMMON-SPACE 0 0;
      text-align: center;

      &.finished {
        background-color: #67C23A;
        color: #ffffff;
      }

      &.not-full-marks {
        background-color: #E6A23C;
        color: #ffffff;
      }

      &.deleted {
        text-decoration: line-through;
        background-color: #bbbbbb;
        color: #ffffff;
      }

      &.checking {
        background-color: #349efb;
        color: #ffffff;
      }
    }
  }
}

.check-item-right {
  $CHECK-ITEM-RIGHT-HEADER-HEIGHT: 100px;
  $CHECK-ITEM-RIGHT-BODY-RIGHT-WIDTH: 35%;

  position: relative;
  padding: $CHECK-ITEM-RIGHT-HEADER-HEIGHT 20px 20px 20px;

  .check-item-right-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $CHECK-ITEM-RIGHT-HEADER-HEIGHT;
    padding: 0 20px;

    .check-item-right-header-inner {
      position: relative;
      width: 100%;
      height: 100%;
      padding-right: $CHECK-ITEM-RIGHT-BODY-RIGHT-WIDTH;

      .section-title {
        padding-top: 12px;
      }

      .check-item-content-wrapper {
        $CHECK-ITEM-NO-WIDTH: 56px;

        position: relative;
        height: 56px;
        margin-top: 10px;
        padding-left: $CHECK-ITEM-NO-WIDTH;

        .check-item-no {
          position: absolute;
          font-size: 32px;
          top: 0;
          left: 0;
          width: $CHECK-ITEM-NO-WIDTH;
          height: 100%;
          line-height: 56px;
          color: #ffffff;
          background-color: #292c33;
          text-align: center;
        }

        .check-item-content {
          position: relative;
          font-size: 16px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 100%;
          height: 100%;

          .check-item-content-inner {
            line-height: 1;
            padding: 0 0 0 20px;
          }

          .check-item-content-status-switch {
            display: flex;
            align-items: center;
            line-height: 1;
            padding: 0 0 0 20px;
          }
        }
      }

      .pre-next-subject {
        position: absolute;
        top: 0;
        right: 0;
        width: $CHECK-ITEM-RIGHT-BODY-RIGHT-WIDTH;
        height: 100%;
        padding-top: 37px;

        button {
          float: right;
          width: 100px;
          height: 26px;
          margin-left: 5px;
          border: 0;
          background: {
            color: transparent;
            size: 100%;
            position: center;
            repeat: no-repeat;
          }
        }

        .pre-subject {
          background-image: url("../../assets/imgs/bt_p.png");

          &:active {
            background-image: url("../../assets/imgs/bt_p_act.png");
          }

          &:disabled {
            background-image: url("../../assets/imgs/bt_p_dis.png");
          }
        }

        .next-subject {
          background-image: url("../../assets/imgs/bt_n.png");

          &:active {
            background-image: url("../../assets/imgs/bt_n_act.png");
          }

          &:disabled {
            background-image: url("../../assets/imgs/bt_n_dis.png");
          }
        }
      }

      .submit-layer {
        position: absolute;
        top: 0;
        right: 0;
        width: $CHECK-ITEM-RIGHT-BODY-RIGHT-WIDTH;
        height: 100%;
        padding-top: 37px;

        button {
          float: right;
          width: 100px;
          height: 26px;
          margin-left: 5px;
          border: 0 {
            radius: 13px;
          };
        }

        .submit-btn {
          border-color: #FE7300;
          background-color: #FE7300;
          color: #FFF;

          &:active {
            border-color: #EA6C2D;
            background-color: #EA6C2D;
          }
        }
      }
    }
  }

  .check-item-right-body {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 10px $CHECK-ITEM-RIGHT-BODY-RIGHT-WIDTH 0 0;
    color: #353941;

    .check-item-right-body-left {
      width: 100%;
      height: 100%;

      .check-item-desc {
        position: relative;
        width: 100%;
        height: 35%;
        padding-top: 20px;

        .section-title {
          position: absolute;
          top: 0;
          left: 0;
        }

        .check-item-desc-text {
          width: 100%;
          height: 100%;
          padding: 8px;
          border: 1px solid #cfd0d3 {
            radius: 10px;
          };
        }
      }

      .check-item-opt {
        width: 100%;
        height: 65%;
        padding-top: 12px;

        .check-item-opt-inner {
          width: 100%;
          height: 100%;
          margin: 0;
          padding: 8px;
          border: 1px solid #cfd0d3 {
            radius: 10px;
          };
          overflow: auto;
        }
      }
    }

    .check-item-right-body-right {
      position: absolute;
      top: 10px;
      right: 0;
      bottom: 0;
      width: $CHECK-ITEM-RIGHT-BODY-RIGHT-WIDTH;
      padding-left: 20px;

      .check-item-remark {
        width: 100%;
        height: 35%;
        padding-top: 20px;

        .section-title {
          position: absolute;
          top: 0;
          left: 20px;
        }

        .check-item-remark-input {
          width: 100%;
          height: 100%;

          textarea {
            font-size: 1rem;
            width: 100%;
            height: 100%;
            padding: 8px;
            outline: 0;
            border: 1px solid #cfd0d3 {
              radius: 10px;
            };
            resize: none;
          }
        }
      }

      .check-item-img {
        height: 65%;
        padding-top: 12px;

        .check-item-img-inner {
          position: relative;
          width: 100%;
          height: 100%;
          padding-top: 20px;

          .section-title {
            position: absolute;
            top: 0;
            left: 0;
          }

          .check-item-img-input {
            position: relative;
            width: 100%;
            height: 100%;

            .check-item-img-display {
              position: absolute;
              width: 30%;
              height: 30%;
            }
          }
        }
      }
    }
  }
}

.section-title {
  font-size: 14px;
  line-height: 1;
  color: #b8b8b9;
}

.form-opt {
  > * {
    /*display: inline-block;*/
    vertical-align: middle;

    &:first-child {
      margin: 0;
    }
  }
}

.form-input {
  margin-top: 5px;
}

.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/07Grade/index.vue